// @flow
import React, { Component } from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";

import type { ErrorsType } from "../../types/UserFormType";
import { ErrosDisplay, setErrorMsg } from "../../containers/ErrosDisplay";
import UserStatusLabel from "../../components/users/UserStatusLabel";
import { DeleteButton, ConfirmCancelDialog } from "imagus-components";

type UserItemPropsType = {
  user: { [key: string]: * },
  isImagusAdmin?: boolean,
  deleteUser: Function,
  openSnackbar?: Function
};

type UserItemStatesType = {
  errors: ErrorsType,
  isLoading: boolean,
  dialogOpen: boolean
};

class UserItem extends Component<UserItemPropsType, UserItemStatesType> {
  constructor(props: UserItemPropsType) {
    super(props);
    this.state = {
      errors: {},
      isLoading: false,
      dialogOpen: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  deleteUser = (userCognitoId: string): * => {
    this.props.deleteUser(
      userCognitoId,
      (): * => {
        this.props.openSnackbar && this.props.openSnackbar(11);
        this.setState({ isLoading: false });
      },
      (errors: *): * => this.setState({ errors: errors })
    );
  };

  render(): * {
    const user = this.props.user;
    return (
      <ListItem divider>
        <div className="top-banner">
          <ErrosDisplay errors={this.state.errors} form="user item" />
        </div>
        <ListItemIcon>
          <UserStatusLabel userStatus={user.user_status} />
        </ListItemIcon>
        <ListItemText
          primary={user.fullName}
          secondary={
            <span>
              <span>
                Email:
                <b>
                  <span className="left-margin-5 right-margin-10">
                    {user.email}
                  </span>
                </b>
              </span>
              {user.defaultFacebase && (
                <span>
                  Linked System:
                  <b>
                    <span className="left-margin-5">
                      {user.defaultFacebase.name}
                    </span>
                  </b>
                </span>
              )}
            </span>
          }
        />
        {this.props.isImagusAdmin && (
          <ListItemSecondaryAction>
            <DeleteButton
              loading={this.state.isLoading}
              noMargin
              onClick={(): * => this.switchModalStatus("dialogOpen")(true)}
            />
            <ConfirmCancelDialog
              open={this.state.dialogOpen}
              handleModalStatus={this.switchModalStatus("dialogOpen")}
              deleteFunction={(): * => {
                this.setState({ isLoading: true });
                this.deleteUser(user.cognitoUuid);
              }}
              itemName={user.fullName}
              extraWord={
                "from the system? This will delete all records for " +
                user.fullName +
                " permanently"
              }
            />
          </ListItemSecondaryAction>
        )}
      </ListItem>
    );
  }
}

export default UserItem;
